// extracted by mini-css-extract-plugin
export var black = "_3l-6";
export var brand = "_3l-1";
export var ddefault = "_3l-0";
export var error = "_3l-3";
export var gray = "_3l-2";
export var highContrast = "_3l-8";
export var outline = "_3l-7";
export var success = "_3l-5";
export var warning = "_3l-4";